<template>
  <div class="nav Box">
    <div class="NavBox limitBox" v-if="!$route.meta?.center">
      <router-link
        v-for="(item, index) in state.NavList"
        :key="index"
        :to="item.path"
        :class="paths == item.path ? 'NavClass active' : 'NavClass'"
      >
        <span @click="ExternalLinks(item)">{{ item.name }}</span>
      </router-link>
      <div class="NavClass Hover">
        <span :class="paths == '/About' ? 'active' : ''" @click="ExternalLinks({inlink: '/About'})">关于我们</span>
        <div>
          <span @click="ExternalLinks({inlink: '/About', query: {c: 0}})">协会简介</span>
          <span @click="ExternalLinks({inlink: '/About', query: {c: 1}})">协会章程</span>
          <span @click="ExternalLinks({inlink: '/About', query: {c: 2}})">组织机构</span>
          <span @click="ExternalLinks({inlink: '/About', query: {c: 3}})">联系我们</span>
        </div>
      </div>
      <div class="NavClass">
        <span :class="paths == '/News' ? 'active' : ''" @click="ExternalLinks({inlink: '/News'})">新闻资讯</span>
      </div>
      <div class="NavClass Hover">
        <span :class="paths == '/Notice' ? 'active' : ''" @click="ExternalLinks({inlink: '/Notice'})">通知公告</span>
        <div>
          <span @click="ExternalLinks({inlink: '/Notice', query: {c: 5}})">协会公告</span>
          <span @click="ExternalLinks({inlink: '/Notice', query: {c: 6}})">联盟公告</span>
        </div>
      </div>
      <div class="NavClass Hover">
        <span :class="paths == '/Member' ? 'active' : ''" @click="ExternalLinks({inlink: '/Member'})">会员服务</span>
        <div>
          <span @click="ExternalLinks({inlink: '/Member'})">会员单位</span>
          <span @click="ExternalLinks({inlink: '/MemberNews'})">会员风采</span>
        </div>
      </div>
      <div class="NavClass Hover">
        <span :class="paths == '/Teams' ? 'active' : ''" @click="ExternalLinks({inlink: '/TeamsHome'})">团标管理</span>
        <div>
          <span @click="ExternalLinks({inlink: '/TeamsHome'})">申请流程</span>
          <span @click="ExternalLinks({inlink: '/Teams', query: {c: 9}})">发布公告</span>
          <span @click="ExternalLinks({inlink: '/Teams', query: {c: 10}})">征求意见</span>
          <span @click="ExternalLinks({inlink: '/Teams', query: {c: 11}})">制修订计划</span>
          <span @click="ExternalLinks({inlink: '/Teams', query: {c: 12}})">文件下载</span>
          <span @click="ExternalLinks({inlink: '/Teams', query: {c: 13}})">意见反馈</span>
        </div>
      </div>
      <div class="NavClass Hover">
        <span :class="paths == '/Standard' ? 'active' : ''" @click="ExternalLinks({inlink: '/Standard'})">现行标准查询</span>
        <div>
          <span @click="ExternalLinks({inlink: '/Standard', query: {c: 7}})">协会团体标准</span>
          <span @click="ExternalLinks({inlink: '/Standard', query: {c: 8}})">广西地方标准</span>
        </div>
      </div>
      <div class="NavClass Hover">
        <span>八桂杯</span>
        <div>
          <span @click="ExternalLinks({outlink: state.bim_url})">报名入口</span>
          <span @click="ExternalLinks({outlink: state.bim_name_list})">获奖名单</span>
        </div>
      </div>
      <div class="NavClass Hover">
        <span @click="ExternalLinks({outlink: 'https://gxjskj.yunxida.com/'})">科技计划项目申报</span>
      </div>
    </div>
    <div class="NavBox limitBox" v-else>
      <p class="BackText" @click="GoBack"><span> &lt; 返回主站</span></p>
    </div>
  </div>
</template>

<script>
import * as Vue from "vue";
import router from "@/router";
import { useRoute } from "vue-router";
import { watchEffect } from "vue";
import api from "@/comment/request/api";

export default {
  name: "NavBar",
  components: {},
  setup(props, { attrs, slots, emit }) {
    const state = Vue.reactive({
      NavList: [
        {
          id: 1,
          path: "/",
          name: "首页",
        },
      ],
      bim_url: '',
      bim_name_list: '',
    });
    const paths = Vue.ref("/");
    const route = useRoute();
    watchEffect(() => {
      paths.value = router.currentRoute.value.meta.path
        ? router.currentRoute.value.meta.path
        : route.path;
    });
    // 返回
    const GoBack = () => {
      router.push({ name: "Home" });
    };
    const ExternalLinks = (item) => {
      if (item.outlink) {
        window.open(item.outlink, "_black");
      }
      if (item.inlink) {
        router.push({ path: item.inlink, query: item.query || {} });
      }
    };
    // 八桂杯
    api.GetConfigs('bim_url,bim_name_list').success((res) => {
      state.bim_url = res.data.data.bim_url;
      state.bim_name_list = res.data.data.bim_name_list;
    });
    return {
      state,
      paths,
      GoBack,
      ExternalLinks,
    };
  },
};
</script>

<style lang="scss" scoped>
@import "/src/comment/comment";
.nav {
  height: 60px;
  margin: 0 auto;
  background-color: #008fd7;
  // overflow: hidden;
  .NavBox {
    height: 60px;
    background-color: #008fd7;
    display: flex;
    justify-content: space-between;
    align-items: center;
    text-align: center;

    .NavClass {
      // flex: 1 1 auto;
      flex: 1;
      color: white;
      text-decoration: none;
      height: 35px;
      line-height: 35px;
      vertical-align: middle;
      z-index: 50;
      font-weight: 400;
      font-size: 18px;
      span {
        border-left: 1px solid #fff;
        width: 100%;
        text-align: center;
        display: inline-block;
        font-family: PingFangSC-Regular, PingFang SC;
        color: #ffffff;
        cursor: pointer;
      }
    }
    .NavClass:last-child {
      >span {
        border-right: 1px solid #fff;
      }
    }
    .Hover {
      >div {
        width: 100%;
        display: none;
        background-color: #008fd7;
        font-size: 18px;
        z-index: 100;
        border-bottom-left-radius: 20px;
        border-bottom-right-radius: 20px;
        padding-top: 5px;
        span {
          border: none;
          margin-top: 5px;
          line-height: 35px;
        }
        span:last-child {
          margin-bottom: 15px;
        }
      }
    }
    .Hover:hover {
      >div {
        display: block;
        span:hover {
          font-weight: 600;
        }
      }
    }


    .active {
      font-size: 19px;
      font-family: PingFangSC-Semibold, PingFang SC;
      font-weight: 600;
    }
  }
}
.BackText {
  font-size: 17px;
  font-family: PingFangSC-Semibold, PingFang SC;
  font-weight: 600;
  color: #ffffff;
  cursor: pointer;
}
</style>